import React from "react";
import * as R from "ramda";
import { Modal, Spin } from "antd";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import { linkToCompanies } from "../../store/actions/company";

import VinculationsTable, { vinculationStatuses } from "./VinculationsTable";
import RejectForm from "./RejectForm";
import AcceptLinkSuccess from "./AcceptLinkSuccess";

const CenteredSpin = () => (
  <div style={{ textAlign: "center" }}>
    <Spin />
  </div>
);

const CompanyList = ({ vinculations, company, loading, linkToCompanies }) => {
  const { t } = useTranslation(["components", "global", "vinculations"]);

  if (loading) {
    return <Spin />;
  }

  const acceptVinculations = companies => {
    const modal = Modal.info({
      icon: null,
      okButtonProps: { style: { display: "none" } },
      content: <CenteredSpin />,
      maskClosable: false
    });

    linkToCompanies(
      companies.map(({ idCompany }) => ({
        idCompany,
        status: vinculationStatuses.linked
      }))
    )
      .then(() => {
        modal.update({
          maskClosable: true,
          content: (
            <AcceptLinkSuccess
              company={company}
              vinculations={companies}
              onContinue={() => modal.destroy()}
              t={t}
            />
          )
        });
      })
      .catch(e => {
        console.error(e);
        modal.destroy();
      });
  };

  const rejectVinculations = companies => {
    const modal = Modal.confirm({
      icon: null,
      width: 480,
      okButtonProps: { style: { display: "none" } },
      cancelButtonProps: { style: { display: "none" } },
      content: (
        <RejectForm
          companies={companies}
          onCancel={() => modal.destroy()}
          onSubmit={rejectReason => {
            modal.update({
              content: <CenteredSpin />
            });
            linkToCompanies(
              companies.map(({ idCompany }) => ({
                idCompany,
                status: vinculationStatuses.rejected,
                reason: rejectReason
              }))
            ).finally(modal.destroy);
          }}
          t={t}
        />
      ),
      footer: null
    });
  };

  return (
    <VinculationsTable
      type="companies"
      data={vinculations}
      onLink={acceptVinculations}
      onUnlink={rejectVinculations}
      loading={loading}
      disableCheckboxFilter={status => status === vinculationStatuses.unlinked}
      unlinkFilter={({ status }) =>
        status === vinculationStatuses.pending ||
        status === vinculationStatuses.linked
      }
      linkFilter={({ status }) =>
        status === vinculationStatuses.pending ||
        status === vinculationStatuses.rejected
      }
      allowLink={true}
      tabs={[
        {
          name: t("vinculations:filters.all"),
          icon: "unordered-list",
          default: true
        },
        {
          name: t("vinculations:filters.requests"),
          icon: "mail",
          filter: R.propEq("status", vinculationStatuses.pending)
        },
        {
          name: t("vinculations:filters.linked"),
          icon: "check-circle",
          filter: R.propEq("status", vinculationStatuses.linked)
        },
        {
          name: t("vinculations:filters.rejected"),
          icon: "close-circle",
          filter: R.propEq("status", vinculationStatuses.rejected)
        }
      ]}
      translateKey="companies"
      data-test="company-list"
    />
  );
};

export default connect(
  state => ({
    company: R.propOr({}, "company", state),
    vinculations: R.pipe(
      R.pathOr([], ["company", "companyVinculations", "requiredToMe"]),
      R.reject(R.propEq("status", vinculationStatuses.unlinked))
    )(state)
  }),
  {
    linkToCompanies
  }
)(CompanyList);
